import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { APIResponse } from '../models/response';

import { Observable } from 'rxjs/Observable';
import { stringify } from '@angular/compiler/src/util';

@Injectable()
export class TicketAttachmentService {
  constructor(private apiService: ApiService) {}

  attachmentsValidation(fileList: FileList): APIResponse<string, any> {
    let fileCount = fileList.length;
    let totalAttachmentSize = 0;
    let validation: APIResponse<string, any> = new APIResponse();
    validation.data = null;
    validation.errors = null;
    validation.success = false;

    if (fileCount > 0) {
      // if attachment exist, do attachments validation
      for (let i = 0; i < fileCount; i++) {
        // do check filetype
        validation = this._checkFileType(fileList[i].name, fileList[i].type);

        if (!validation.success) {
          return validation;
        }
        // checking total attachment size
        const attachmentSize = totalAttachmentSize + fileList[i].size;
        if (attachmentSize > 2048000) {
          validation.errors = 'Total files size must not exceed 2 MB';
          validation.success = false;
          console.log(validation);
          return validation;
        }

        totalAttachmentSize += fileList[i].size;
      }
      validation.errors = null;
      validation.success = true;
      return validation;
    }
  }

  // check file type (non images) for icon usage
  private _checkFileType(filename: string, type: string) {
    let errMessage: APIResponse<string, any> = new APIResponse();
    errMessage.data = null;
    errMessage.errors = null;
    errMessage.success = null;
    const fileType = this._checkImagePDFType(type);

    if (fileType === 'else') {
      const not_images = filename.substring(
        filename.indexOf('.'),
        filename.length
      );
      if (not_images === '.docx' || not_images === '.doc') {
        errMessage.data = 'word';
        errMessage.errors = null;
        errMessage.success = true;
      } else if (not_images === '.xlsx' || not_images === '.xls') {
        errMessage.data = 'excel';
        errMessage.errors = null;
        errMessage.success = true;
      } else if (not_images === '.zip') {
        errMessage.data = 'zip';
        errMessage.errors = null;
        errMessage.success = true;
      } else {
        errMessage.data = null;
        errMessage.errors =
          'FileType Not Allowed (only .jpg, .png, .gif, .pdf, .docx, .doc, .xls, .xlsx, and .zip)';
        errMessage.success = false;
      }
    } else {
      errMessage.data = fileType;
      errMessage.errors = null;
      errMessage.success = true;
    }
    return errMessage;
  }

  // check file type (images) for icon usage
  private _checkImagePDFType(type: string): string {
    switch (type) {
      case 'image/png':
      case 'image/gif':
      case 'image/jpeg':
        return 'jpg';
      case 'application/pdf':
        return 'pdf';
      default:
        return 'else';
    }
  }

  public removeAttachmentDirectory(
    ticketid: string
  ): Observable<APIResponse<boolean, any>> {
    return this.apiService.get('/attachment/remove/dir/' + ticketid);
  }

  public removeAttachment(
    hashedfilename: string
  ): Observable<APIResponse<boolean, any>> {
    return this.apiService.get('/attachment/remove/item/' + hashedfilename);
  }

  public uploadAttachment(
    attachment: FormData
  ): Observable<APIResponse<string, any>> {
    return this.apiService.post('/attachment/add/', attachment);
  }

  public downloadAttachment(filedata: any) {
    return this.apiService.postDownloadImage('/attachment/download', filedata);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/ticket-attachment.service.ts